import { render, staticRenderFns } from "./app-layout.vue?vue&type=template&id=61108fa8&scoped=true"
import script from "./app-layout.vue?vue&type=script&lang=js"
export * from "./app-layout.vue?vue&type=script&lang=js"
import style0 from "./app-layout.vue?vue&type=style&index=0&id=61108fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61108fa8",
  null
  
)

export default component.exports